import ButtonText from "@visa/vds/button-text";
import Col from "@visa/vds/col";
import Icon from "@visa/vds/icon";
import Row from "@visa/vds/row";
import Typography from "@visa/vds/typography";
import React from "react";
import PostClassification from "../../../components/library/PostClassification";
import PostTypeIcon from "../../../components/library/PostTypeIcon";
import { LibraryPostFileClickAction } from "../../../_constants/GlobalConstants";
import { LibraryPostType, LibraryClassificationType } from "../../../_constants/LibraryConstants";

const Post = (props) => {
  const displayPostId = props.displayPostId === true && props.post.libraryClassificationId === LibraryClassificationType.Public;
  return (
    <>
      <Row>
        <Col xs={2} sm={2} md={2} lg={2} xl={2}>
          <PostClassification
            name={
              props.post.libraryClassificationName != null
                ? props.post.libraryClassificationName
                : ""
            }
            classificationId={props.post.libraryClassificationId}
            productName={
              props.post.productName != null ? props.post.productName : ""
            }
          ></PostClassification>
        </Col>
        <Col xs={2} sm={2} md={1} lg={1} xl={1} textAlign="center">
          <PostTypeIcon type={props.post.type} fileExtension={props.post.fileExtension}></PostTypeIcon>
        </Col>
        <Col xs={2} sm={2} md={4} lg={6} xl={6}>
          <Typography className="library-post-title" tag="h4">
            {displayPostId && "("+props.post.id+") "}{props.post.title}
          </Typography>
          <p className="library-post-description">{props.post.description}</p>
        </Col>
        <Col xs={2} sm={2} md={1} lg={2} xl={3}>
          {props.post.type === LibraryPostType.File && (
            <>
              <ButtonText colorScheme="tertiary" onClick={() => props.handleClickLinkBtn(props.post, LibraryPostFileClickAction.Download)}>
                <Icon name="file-download" resolution="low" />
                Download
              </ButtonText>
              { props.post.canOpenInBrowser &&
                <ButtonText colorScheme="tertiary" onClick={() => props.handleClickLinkBtn(props.post, LibraryPostFileClickAction.Open)}>
                  <Icon name="search" resolution="low" />
                  Open
                </ButtonText>
              }              
            </>
          )}
          {props.post.type === LibraryPostType.Url && (
            <ButtonText colorScheme="tertiary" onClick={() => props.handleClickLinkBtn(props.post, LibraryPostFileClickAction.Link)}>
              <Icon name="link" resolution="low" />
              Go to link
            </ButtonText>
          )}
        </Col>
      </Row>
    </>
  );
};

export default Post;
